import React from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { Text } from '../components/Texte';
import { SafeAreaView } from 'react-native-safe-area-context';
import { BellOff } from '../components/icons';
import { Card } from '../components/Card';
import { IconPill } from '../components/IconPill';
import { ScreenHeader } from '../components/ScreenHeader';
import { internalNotifications, type AppNotification } from '../data/notifications';
import { colors, screenPadding, spacing, typography } from '../theme/tokens';
import { t } from '../i18n';

export interface NotificationsScreenProps {
  notifications?: AppNotification[];
  onBack?: () => void;
}

export function NotificationsScreen({ notifications = internalNotifications(), onBack }: NotificationsScreenProps) {
  return (
    <SafeAreaView style={styles.container} edges={['top']}>
      <ScreenHeader onBack={onBack} title={t('notifications_screen.title')} testID="notif-back" />

      {notifications.length === 0 ? (
        <View testID="notif-empty" style={styles.empty}>
          <BellOff size={36} color={colors.grey400} strokeWidth={2} />
          <Text style={styles.emptyText}>{t('notifications_screen.empty')}</Text>
        </View>
      ) : (
        <ScrollView contentContainerStyle={styles.list}>
          {notifications.map((n) => (
            <Card key={n.id} testID={`notif-item-${n.id}`}>
              <View style={styles.row}>
                <IconPill icon={n.icon} accent={n.accent} variant="soft" size={40} />
                <View style={styles.texts}>
                  <Text style={styles.title}>{n.title}</Text>
                  <Text style={styles.body}>{n.body}</Text>
                </View>
              </View>
            </Card>
          ))}
        </ScrollView>
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: colors.grey50 },
  empty: { flex: 1, alignItems: 'center', justifyContent: 'center', gap: spacing.md, paddingHorizontal: screenPadding },
  emptyText: { fontSize: typography.body.size, color: colors.grey500, textAlign: 'center' },
  list: { padding: screenPadding, gap: spacing.md },
  row: { flexDirection: 'row', alignItems: 'flex-start', gap: spacing.md },
  texts: { flex: 1, gap: spacing.xs },
  title: { fontSize: typography.h3.size, fontWeight: typography.h3.weight, color: colors.grey900 },
  body: { fontSize: typography.body.size, lineHeight: typography.body.lineHeight, color: colors.grey700 },
});
